import { useRef } from "react";
import MobileMenuToggle from "./mobile-menu-toggle";
import MobileMenuDropdown from "./mobile-menu-dropdown";
import { hasMobileNavActive, toggleMobileMenu } from "~/utils/menu";
import { Link, NavLink, useLoaderData } from "react-router";
import type { Tag } from "~/models/tag";
import NavMenu from "./navmenu";

export default function NavBar() {
    const initialMenu = useLoaderData<Tag[]>();
    
    return (
        <>
            <header id="header" className="fixed-top">
                <div className="d-flex align-items-center container">

                    <span className="logo me-auto">
                        <Link to='/'>
                            Constellation<br /><div className='second text-end'>training</div>
                        </Link>
                    </span>

                    <NavMenu />

                </div>
            </header>
        </>
    );
}
